import {AppLocalDate} from '@/lib/date-utils'

/**
 * Resolves a template expression against a context.
 *
 * Supported tokens:
 *   ${template.X} → templateContext['X']
 *   ${today}      → current local date (YYYY-MM-DD)
 *   ${anything}   → empty string if unknown
 *
 * SECURITY: This function MUST NOT use eval() or dangerouslySetInnerHTML.
 * All interpolation is done by string replacement only.
 */
export function resolveTemplateExpression(
    expr: string,
    templateContext: Record<string, string>
): string {
    if (!expr) return ''

    const today = AppLocalDate.today()
    return expr.replace(/\$\{([^}]+)\}/g, (_, token: string) => {
         
        if (token === 'today') return today
         
        if (token.startsWith('template.')) {
             
            const key = token.slice('template.'.length)
            return templateContext[key] ?? ''
        }
        return templateContext[token] ?? ''
    })
}
